'use strict'

import Helper from '@/utils/helper'

const DEFAULT_DURATION_SEC = 30

class AdTextItem {
  constructor ({ id, type, frequency, message, durationSec }) {
    Helper.checkInt('AdTextItem.id', id)
    Helper.checkInt('AdTextItem.type', type)
    Helper.checkInt('AdTextItem.frequency', frequency)
    Helper.checkString('AdTextItem.message', message)
    if (Helper.isDefined(durationSec)) {
      Helper.checkInt('AdTextItem.durationSec', durationSec)
    }

    this.id = id
    this.type = type
    this.frequency = frequency
    this.message = message
    this.durationSec = Helper.isDefined(durationSec) ? durationSec : DEFAULT_DURATION_SEC
  }

  getId () {
    return this.id
  }

  getType () {
    return this.type
  }

  getFrequency () {
    return this.frequency
  }

  getMessage () {
    return this.message
  }

  getDurationSec () {
    return this.durationSec
  }

  toString () {
    return 'AdTextItem{' +
      'id=' + '\'' + this.id + '\'' +
      ', type=' + '\'' + this.type + '\'' +
      ', frequency=' + '\'' + this.frequency + '\'' +
      ', message=' + '\'' + this.message + '\'' +
      ', durationSec=' + '\'' + this.durationSec + '\'' +
      '}'
  }
}

export default AdTextItem
